import { useAxios } from "./../lib/AxiosProvider";

// Requests for the admin pages. All of them send the admin login.
const useAdmin = () => {
	const axios = useAxios();

	const getStats = async () => {
		const { data } = await axios.get("/admin/stats");
		return data;
	};

	const getDonors = async ({ skip = 0, limit = 30, text = "", sortBy = "", blood = "", status = "" } = {}) => {
		const { data } = await axios.get("/admin/donor-list", {
			params: { skip, limit, text, sortBy, blood, status },
		});
		return data;
	};

	const setBlocked = async ({ id, isBan }) => {
		const { data } = await axios.post("/admin/user-block", { id, isBan });
		return data;
	};

	const getNotes = async (userId) => {
		const { data } = await axios.get("/admin/notes", { params: { userId } });
		return data;
	};

	const addNote = async ({ userId, text }) => {
		const { data } = await axios.post("/admin/notes", { userId, text });
		return data;
	};

	const deleteNote = async (id) => {
		const { data } = await axios.delete(`/admin/notes/${id}`);
		return data;
	};

	const getPhotos = async ({ pageParam = 0 }) => {
		if (pageParam === 0) {
			const { data } = await axios.get("/admin/initial-photos");
			return { photos: data.photos, count: data.count };
		}
		const { data } = await axios.get("/admin/load-more-photos", { params: { skip: pageParam } });
		return { photos: data };
	};

	const uploadPhoto = async (file) => {
		const formData = new FormData();
		formData.append("file", file);
		const { data: uploaded } = await axios.post("/image-upload", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		await axios.post("/admin/save-gallary-photo", { photo: uploaded.url });
		return uploaded;
	};

	const deletePhoto = async (id) => {
		const { data } = await axios.delete("/admin/delete-galary-photo", { params: { id } });
		return data;
	};

	return {
		getStats,
		getDonors,
		setBlocked,
		getNotes,
		addNote,
		deleteNote,
		getPhotos,
		uploadPhoto,
		deletePhoto,
	};
};

export default useAdmin;
